/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Auth_Signup_Toast_Verify_Email_DescriptionInputs */

const en_auth_signup_toast_verify_email_description = /** @type {(inputs: Auth_Signup_Toast_Verify_Email_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`We sent a verification link to confirm your account.`)
};

const pl_auth_signup_toast_verify_email_description = /** @type {(inputs: Auth_Signup_Toast_Verify_Email_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wysłaliśmy link weryfikacyjny, aby potwierdzić Twoje konto.`)
};

/**
* | output |
* | --- |
* | "We sent a verification link to confirm your account." |
*
* @param {Auth_Signup_Toast_Verify_Email_DescriptionInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const auth_signup_toast_verify_email_description = /** @type {((inputs?: Auth_Signup_Toast_Verify_Email_DescriptionInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Auth_Signup_Toast_Verify_Email_DescriptionInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_auth_signup_toast_verify_email_description(inputs)
	return en_auth_signup_toast_verify_email_description(inputs)
});